module.exports = __webpack_public_path__ + "img/on-going.45349e34.svg";